// The API's roles are levels: each one has the rights of every role below it
// (admin ⊃ staff ⊃ customer ⊃ user ⊃ visitor, see the API's src/middlewares/auth.js).
// Compare against a minimum level instead of an exact role, so staff and admins also get customer features.
export const ROLE_LEVELS = ['visitor', 'user', 'customer', 'staff', 'admin'] as const

export type Role = typeof ROLE_LEVELS[number]

/** The user's level; unknown or missing roles count as visitor, as the API treats them. */
export const roleLevel = (role: unknown) => Math.max(0, ROLE_LEVELS.indexOf(role as Role))

/** Whether `role` is `min` or higher. This only shows or hides UI; the API enforces the rights. */
export const hasRole = (role: unknown, min: Role) => roleLevel(role) >= roleLevel(min)
